import { render, staticRenderFns } from "./ResetSuccess.vue?vue&type=template&id=0767b257&scoped=true&"
import script from "./ResetSuccess.vue?vue&type=script&lang=ts&"
export * from "./ResetSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./ResetSuccess.vue?vue&type=style&index=0&id=0767b257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0767b257",
  null
  
)

export default component.exports